import {
  CONTENT_STATUS,
  MATERIAL_TYPES,
  SEGMENTATION_OPTIONS,
} from "../constants";

export function formatDateOnly(value) {
  if (!value) return "";
  const str = String(value).trim();
  if (str.includes("T")) {
    const iso = str.split("T")[0];
    return toBrazilianDate(iso);
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
    return toBrazilianDate(str);
  }
  return str;
}

function toBrazilianDate(isoDate) {
  const [year, month, day] = isoDate.split("-");
  if (!year || !month || !day) return isoDate;
  return `${day}-${month}-${year}`;
}

export function formatDateTimeLocal(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function mapSegmentacaoToForm(segmentacao) {
  if (!segmentacao?.length) return null;
  const tipo = segmentacao[0]?.TipoSegmentacao;
  return SEGMENTATION_OPTIONS.find((s) => s.value === tipo) || null;
}

export function populateCampaignForm(
  campaign,
  categoryOptions,
  materialOptions,
  videoOptions,
) {
  if (!campaign) return null;

  const linkedIds = campaign.IdsConteudosVinculados || [];
  const materiaisVinculados = materialOptions.filter((o) =>
    linkedIds.includes(o.value),
  );
  const videosVinculados = videoOptions.filter((o) =>
    linkedIds.includes(o.value),
  );

  return {
    nome: campaign.Nome || campaign.Titulo || "",
    descricao: campaign.Descricao || "",
    categoria:
      categoryOptions.find(
        (c) => c.value === campaign.IdFranquiaMarketingCategoria,
      ) ||
      categoryOptions.find((c) => c.label === campaign.NomeCategoria) ||
      null,
    dataInicio: formatDateOnly(campaign.DataInicio),
    dataFim: formatDateOnly(campaign.DataFim),
    status:
      CONTENT_STATUS.find((s) => s.value === campaign.Status) || null,
    destaqueHome: !!campaign.DestaqueHome,
    ordemExibicao: String(campaign.OrdemExibicao ?? ""),
    segmentacao: mapSegmentacaoToForm(campaign.Segmentacao),
    tags: (campaign.Tags || []).join(", "),
    materiaisVinculados,
    videosVinculados,
    dataPublicacaoAgendada: formatDateTimeLocal(campaign.DataPublicacaoAgendada),
    id: campaign.IdFranquiaMarketingCampanha,
  };
}

export function populateContentForm(
  content,
  categoryOptions,
  campaignOptions,
  playlistOptions,
) {
  if (!content) return null;

  return {
    nome: content.Titulo || "",
    descricao: content.Descricao || "",
    categoria:
      categoryOptions.find(
        (c) => c.value === content.IdFranquiaMarketingCategoria,
      ) ||
      categoryOptions.find((c) => c.label === content.NomeCategoria) ||
      null,
    campanha:
      campaignOptions.find(
        (c) => c.value === content.IdFranquiaMarketingCampanha,
      ) || null,
    playlist:
      playlistOptions.find(
        (p) => p.value === content.IdFranquiaMarketingPlaylist,
      ) || null,
    dataInicio: formatDateOnly(content.DataInicioVigencia),
    dataFim: formatDateOnly(content.DataFimVigencia),
    status: CONTENT_STATUS.find((s) => s.value === content.Status) || null,
    segmentacao: mapSegmentacaoToForm(content.Segmentacao),
    tags: (content.Tags || []).join(", "),
    url: content.UrlExterna || "",
    duracao: content.DuracaoSegundos
      ? `${Math.floor(content.DuracaoSegundos / 60)}:${String(content.DuracaoSegundos % 60).padStart(2, "0")}`
      : "",
    destaqueHome: !!content.DestaqueHome,
    ordemExibicao: String(content.OrdemExibicao ?? ""),
    tipo:
      MATERIAL_TYPES.find((t) => t.value === content.TipoArquivo?.toUpperCase()) ||
      MATERIAL_TYPES[0],
    dataPublicacaoAgendada: formatDateTimeLocal(content.DataPublicacaoAgendada),
    id: content.IdFranquiaMarketingConteudo,
    tipoConteudo: content.Tipo,
  };
}

export function getAgendadoExtraFields(form) {
  if (form.status?.value !== "Agendado") return {};
  if (!form.dataPublicacaoAgendada) return {};
  return { dataPublicacaoAgendada: form.dataPublicacaoAgendada };
}
